<div class="container-fluid">
    <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-12 cadastro">Cadastro</div>
    </div>
    <div class="form-box container-fluid">
        <div class="row">
            <div class="col-12 form-title pt-4">Incentivos</div>
            <div class="col-12 form-subtitle pb-4">Atribuídos ao favorecido
            </div>
            <div class="col-12">
                <div class="py-2 container-fluid">
                    <div class="row">

                    <ng-container *ngFor="let categoria of beneficioGrupo">
                        <ng-container *ngIf="categoria.beneficios.length > 0">
                            <ng-container *ngFor="let item of beneficios; let i= index">
                                <div class="border-beneficio">
                                    <div class="mx-2 mt-4 mb-5">

                                        <p class="form-check-label font-weight-normal">
                                            {{item.produtoNome}}
                                        </p>

                                        <img [src]="'./assets/icons/produtos/icon-produtos/'+
                                            item.produtoGuid +'.svg'" onerror="this.src='./assets/icons/produtos/icon-produtos/SemImagem.svg';" class="img-card mb-5" alt="{{item.produtoNome}}" />

                                        <div class="div-select-create custom-input-container">
                                            <label>Regularidade: {{item.periodo}}</label>
                                        </div>
                                        <div class="custom-input-container">
                                            <span>R$ {{ item.valor}}</span>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </ng-container>


                        <h3 *ngIf="beneficioGrupo.length === 0">O favorecido não possui incentivos</h3>

                    </div>
                    <div class="row button-container mt-5 mb-3">
                        <div class="col-6 text-left">
                            <button type="button" class="custom-button-previous" (click)="previous()">
                                VOLTAR
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
